// R4 PR 2: synchronous in-flight guard for the assistant's sendMessage.
// React's isStreaming state is stale until the next render, so a fast second
// Enter or click could start a second stream and interleave the replies.
// The guard is set synchronously; each stream gets a token so a late finally
// from a cancelled stream cannot clear a newer stream's guard.

export const WAIT_PLACEHOLDER = "Wait for the reply to finish...";

export function createSendGuard() {
  let current = null;
  let seq = 0;
  return {
    /** Returns a token when a new stream may start, or null when one is in flight. */
    tryStart() {
      if (current !== null) return null;
      seq += 1;
      current = seq;
      return current;
    },
    /** Called from the stream's finally; only the owning stream clears the guard. */
    finish(token) {
      if (token !== null && token === current) current = null;
    },
    /** Cancel clears the guard regardless of owner. */
    cancel() {
      current = null;
    },
    isBusy() {
      return current !== null;
    },
  };
}

/** May the user send right now? Blocked while a reply streams or a Confirm card waits. */
export function canSend({ input, isStreaming, pendingAction }) {
  return Boolean(String(input || "").trim()) && !isStreaming && !pendingAction;
}
